import React from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";

export default function DataItem(props) {
  return (
    <Grid
      container
      alignItems="center"
      spacing={1}
      style={props.first ? { marginTop: 5 } : null}
    >
      <Grid item>
        <Typography variant="h5" style={{ fontWeight: 600 }}>
          {props.title}
        </Typography>
      </Grid>
      <Grid item>
        <Typography variant="h6">{props.data}</Typography>
      </Grid>
    </Grid>
  );
}
